"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SuccessMark;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var AnimationSvg = _styledComponents["default"].svg.withConfig({
  displayName: "SuccessMark__AnimationSvg",
  componentId: "sc-1a6yq5n-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["--circle-check-clr:var(--colors-irisBlue);--circle-bg:var(--colors-alabaster);--circle-border-clr:var(--colors-irisBlue);"]);

    case 'dark':
    default:
      return (0, _styledComponents.css)(["--circle-check-clr:var(--colors-turquoise);--circle-bg:var(--colors-irisBlue);--circle-border-clr:var(--colors-blank);"]);
  }
});

var AnimationBase = (0, _styledComponents.css)(["--iterationDuration:1.5s;--spinCount:1;animation-duration:var(--iterationDuration);animation-iteration-count:var(--iterationCount);"]);

var AnimationCircleGroup = _styledComponents["default"].g.withConfig({
  displayName: "SuccessMark__AnimationCircleGroup",
  componentId: "sc-1a6yq5n-1"
})(["transform:rotate(270deg);transform-origin:center;"]);

var CircleLoadingProgress = (0, _styledComponents.keyframes)(["0%{stroke-dashoffset:295%;}100%{stroke-dasharray:-295%;}"]);

var AnimationCircleProgress = _styledComponents["default"].circle.withConfig({
  displayName: "SuccessMark__AnimationCircleProgress",
  componentId: "sc-1a6yq5n-2"
})(["", " animation-name:", ";animation-timing-function:ease-in-out;animation-duration:calc(var(--iterationDuration) * var(--spinCount));animation-iteration-count:1;stroke-dasharray:295%;stroke-dashoffset:-295%;"], AnimationBase, CircleLoadingProgress);

var CheckFillProgress = (0, _styledComponents.keyframes)(["0%{stroke-dashoffset:46%;}100%{stroke-dashoffset:0%;}"]);

var AnimationCheckFillPath = _styledComponents["default"].path.withConfig({
  displayName: "SuccessMark__AnimationCheckFillPath",
  componentId: "sc-1a6yq5n-3"
})(["", " animation-name:", ";animation-timing-function:ease-in-out;animation-fill-mode:forwards;animation-iteration-count:1;animation-delay:calc(var(--iterationDuration) * calc(var(--spinCount) * 0.85));animation-duration:0.2s;stroke-dasharray:45%;stroke-dashoffset:46%;"], AnimationBase, CheckFillProgress);

var SuccessMarkContainer = _styledComponents["default"].div.withConfig({
  displayName: "SuccessMark__SuccessMarkContainer",
  componentId: "sc-1a6yq5n-4"
})(["display:flex;justify-content:center;"]);

function SuccessMark(props) {
  return __jsx(SuccessMarkContainer, props, __jsx(AnimationSvg, {
    width: "98",
    height: "98",
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx(AnimationCircleGroup, null, __jsx("circle", {
    cx: "49",
    cy: "49",
    r: "49",
    fill: "var(--circle-border-clr)",
    fillOpacity: "0.2"
  }), __jsx(AnimationCircleProgress, {
    cx: "49",
    cy: "49",
    r: "45",
    stroke: "var(--circle-check-clr)",
    strokeWidth: "8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), __jsx("circle", {
    cx: "49",
    cy: "49",
    r: "40",
    fill: "#624DE3"
  }), __jsx("circle", {
    cx: "49",
    cy: "49",
    r: "41",
    fill: "var(--circle-bg)"
  }), __jsx("path", {
    d: "M35 50L44 58.5L63 40",
    stroke: "white",
    strokeOpacity: "0.1",
    strokeWidth: "6",
    strokeLinecap: "round"
  }), __jsx(AnimationCheckFillPath, {
    d: "M35 50L44 58.5L63 40",
    stroke: "var(--circle-check-clr)",
    strokeWidth: "6",
    strokeLinecap: "round"
  })));
}